import { accountApi } from "../../config/apiConfig";
import {
  ApplyEroundMappingsResponse,
  EroundMappingLine,
  WallboxEntry,
  WallboxEroundMappingInput,
  WallboxListResponse,
} from "../../types/onboarding";

// `eround`: absent leaves it unchanged, null removes it; the server stamps who
// set it and when.
interface WallboxEntryPayload {
  manufacturer: string;
  model_string: string;
  integrated: boolean;
  eround?: WallboxEroundMappingInput | null;
}

// GET /admin/wallbox — all entries incl. integrated=false.
export const listWallbox = async (): Promise<WallboxListResponse> => {
  const response = await accountApi.get("admin/wallbox");
  return response.data;
};

// POST /admin/wallbox
export const createWallbox = async (
  payload: WallboxEntryPayload
): Promise<WallboxEntry> => {
  const response = await accountApi.post("admin/wallbox", payload);
  return response.data;
};

// PUT /admin/wallbox/{id}
export const updateWallbox = async (
  id: string,
  payload: WallboxEntryPayload
): Promise<WallboxEntry> => {
  const response = await accountApi.put(`admin/wallbox/${id}`, payload);
  return response.data;
};

// DELETE /admin/wallbox/{id} — hard delete (existing prospect model strings unaffected).
export const deleteWallbox = async (id: string): Promise<void> => {
  await accountApi.delete(`admin/wallbox/${id}`);
};

// POST /admin/wallbox/eround-mappings — applies at most 500 reviewed lines;
// each line succeeds or fails on its own.
export const applyEroundMappings = async (
  lines: EroundMappingLine[]
): Promise<ApplyEroundMappingsResponse> => {
  const response = await accountApi.post("admin/wallbox/eround-mappings", { lines });
  return response.data;
};
